import React from "react";
import BrochureForm from "../contact/brochureForm";

export default ({ data, privacy }) => {
  return <BrochureForm data={data} privacy={privacy} />;
};
